module.exports = __webpack_public_path__ + "assets/img/swiper-img4-7537ebd4.png";